import {
  SET_NETWORKS,
  SET_NETWORKS_GROUPINGS,
} from './constants'
import {fetchNetworksConfig} from '@/api'

/** In particular to the
 *  we want to download the data into the application...
 * TODO need to have a better way to organize the code here,
 * the stores are to much scattered and relient on other factors, I need a better way to manage the data
 * this is not the way I want to do it
*/
// TODO move networks to this store???
// TODO need to organize the stores more clearly
const actions = {
  [SET_NETWORKS] ({commit, state}) {
    if (state.networks.length === 0) {
      fetchNetworksConfig().then(networks => {
        commit(SET_NETWORKS, networks.networks)
        commit(SET_NETWORKS_GROUPINGS, networks.categories)
      })
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/networks/store/actions.js